import { z } from "zod";

const UpdateBrandPurchaserStatusSchema = z.object({
  brandId: z.number().int().positive(),
  purchaserId: z.number().int().positive(),
  isActive: z.boolean(),
});

export type UpdateBrandPurchaserStatusDTOShape = z.infer<
  typeof UpdateBrandPurchaserStatusSchema
>;

export class UpdateBrandPurchaserStatusDTO {
  readonly brandId!: number;
  readonly purchaserId!: number;
  readonly isActive!: boolean;

  constructor(data: UpdateBrandPurchaserStatusDTOShape) {
    const validated = UpdateBrandPurchaserStatusSchema.parse(data);
    Object.assign(this, validated);
  }

  static validate(data: unknown) {
    return UpdateBrandPurchaserStatusSchema.safeParse(data);
  }
}
